import { createReducer, on } from '@ngrx/store';
import agreementsActions from './agreements.actions';
import { ApiState } from '../../model/api-state.model';
import { AgreementsApi } from '../../model/agreements.model';
import AppError from '../../model/app-error';

export { agreementsActions as actions };

export * from './agreements.selectors';

export interface State {
  state: ApiState;
  data: AgreementsApi | null;
  error: AppError | null;
}

export const initialState: State = {
  state: ApiState.idle,
  data: null,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(agreementsActions.reset, () => initialState),
  on(agreementsActions.fetchStart, (state) => ({ ...state, state: ApiState.pending, data: null, error: null })),
  on(agreementsActions.fetchSuccess, (state, { data }) => ({ ...state, state: ApiState.success, data, error: null })),
  on(agreementsActions.fetchError, (state, { error }) => ({ ...state, state: ApiState.error, data: null, error })),
);
